import { Check } from 'lucide-react';
import {
  MCPTypeBadge,
  MCPTransportBadge,
  MCPStatusIndicator,
  MCPSourceBadges,
  MCPPublisherFilterOption,
  MCPVersionFilterOption,
} from '@/components/shared/mcp';
import type { MCPType, MCPTransport } from '@kirin/api-client/contracts/mcp';

export { MCPPublisherFilterOption, MCPVersionFilterOption };

interface FilterOptionProps {
  value: string;
  isSelected: boolean;
}

export function MCPTypeFilterOption({ value, isSelected }: FilterOptionProps) {
  return (
    <div className="flex items-center gap-3 flex-1 px-0.5 py-0.5">
      <div className="flex items-center justify-center w-4 h-4 shrink-0">
        {isSelected && (
          <Check className="size-4 text-primary" strokeWidth={2.5} />
        )}
      </div>
      <MCPTypeBadge type={value as MCPType} />
    </div>
  );
}

export function MCPTransportFilterOption({
  value,
  isSelected,
}: FilterOptionProps) {
  return (
    <div className="flex items-center gap-3 flex-1 px-0.5 py-0.5">
      <div className="flex items-center justify-center w-4 h-4 shrink-0">
        {isSelected && (
          <Check className="size-4 text-primary" strokeWidth={2.5} />
        )}
      </div>
      <MCPTransportBadge transport={value as MCPTransport} />
    </div>
  );
}

export function MCPStatusFilterOption({
  value,
  isSelected,
}: FilterOptionProps) {
  return (
    <div className="flex items-center gap-3 flex-1 px-0.5 py-0.5">
      <div className="flex items-center justify-center w-4 h-4 shrink-0">
        {isSelected && (
          <Check className="size-4 text-primary" strokeWidth={2.5} />
        )}
      </div>
      <MCPStatusIndicator runningCount={value === 'running' ? 1 : 0} />
    </div>
  );
}

export function MCPSourceFilterOption({
  value,
  isSelected,
}: FilterOptionProps) {
  return (
    <div className="flex items-center gap-3 flex-1 px-0.5 py-0.5">
      <div className="flex items-center justify-center w-4 h-4 shrink-0">
        {isSelected && (
          <Check className="size-4 text-primary" strokeWidth={2.5} />
        )}
      </div>
      <MCPSourceBadges sources={[value]} />
    </div>
  );
}
